module.exports = __webpack_public_path__ + "static/media/new-check-icon-thin.0f79f202.svg";